import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, forkJoin, map, throwError } from 'rxjs';
import { LoadingService } from './loading.service';
import { catchError } from 'rxjs/operators';
import { IropsMapper } from '@app/mappers';
import { Moment } from 'moment';
import { TypeLoading } from '@app/enums';
import { Reservation } from '@app/models/micro';
import { ApiService } from './micro/api.service';

@Injectable({
  providedIn: 'root',
})
export class IropsService {
  urlIrops = environment.urlApiWeb + 'v4/exchanges/am-exchanges-api';
  urlIropsPu = environment.urlApiWeb + 'v1/exchanges/am-exchanges-api';
  // BFF sin cifrar por ahora (encrypted: false en encrypted-endpoints).
  urlMicro = `${environment.urlApiCheckinBFF}${environment.versionCheckin}/kiosk/checkin/flightstatus`;
  iropCartID: string;
  listFlights: any;
  flightSelect: any;
  responseItinerary: any;
  dateSelected: Moment;
  fareType: string;

  private _pnrResponse: {
    cartId: string;
    multiCity: boolean;
    cityPairDates: string;
    travelers: string;
    exchangeType: string;
    store: string;
    language: string;
  };
  constructor(
    private _apiService: ApiService,
    private http: HttpClient,
    private _loadingService: LoadingService
  ) {}

  getPNR(pnr: string, lastName: string, hasCkiPax: boolean): Observable<any> {
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http
      .get(
        `${this.urlIrops}/pnr/exchange/${pnr}?lastName=${lastName}&store=mx&language=es&pos=kiosk&isCheckin=${hasCkiPax}&isPriorityList=false&isCheckedBags=false`
      )
      .pipe(
        map((response) => {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          return response;
        }),
        catchError((error) => this.handlerError(error))
      );
  }

  getDetails(pnr: any): Observable<any> {
    return this.http
      .get(
        `${this.urlIrops}/fare/exchange/detailed?cartId=${pnr.cartId}&multi-city=${pnr.multiCity}&city-pair-dates=${pnr.cityPairDates}&travelers=${pnr.travelers}&exchangeType=${pnr.exchangeType}&isSDC=true&store=${pnr.store}&language=${pnr.language}&pos=kiosk`
      )
      .pipe(
        map((response) => {
          return IropsMapper.flights(response, this.fareType);
        }),
        catchError((error) => this.handlerError(error))
      );
  }

  setItinerary(pnr: any, body: any): Observable<any> {
    const timeOfRequest = new Date().getTime().toString();
    const p = {
      exchangeType: pnr.exchangeType,
      timeOfRequest,
      pos: 'kiosk',
      store: 'MX',
      overrideTsa: 'true',
      overrideDocv: 'true',
      kioskId: 'ATOMEXK01',
      uiVersion: '4.5.19-109',
      languageUI: 'es_MX',
      location: 'MEX',
      currency: 'MXN',
      paymentEnabled: 'true',
      'multi-city': pnr.multiCity,
      travelers: pnr.travelers,
      market: body.market,
    };

    const params = new HttpParams({ fromObject: p });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);

    return this.http
      .put<any>(
        `${this.urlIrops}/cart/exchange/itinerary/${pnr.cartId}`,
        IropsMapper.mapSelectedRequest(body),
        { params }
      )
      .pipe(
        map((response) => {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          return response;
        }),
        catchError((error) => this.handlerError(error))
      );
  }

  doPurchase(pnr: any, body: any) {
    const timeOfRequest = new Date().getTime().toString();
    const p = {
      cartId: pnr.cartId,
      exchangeType: pnr.exchangeType,
      timeOfRequest,
      pos: 'kiosk',
      store: 'MX',
      overrideTsa: 'true',
      overrideDocv: 'true',
      kioskId: 'ATOMEXK01',
      uiVersion: '4.5.19-109',
      language: 'es',
      location: 'MEX',
      currency: 'MXN',
      Payment: 'true',
      paymentEnabled: 'true',
      'multi-city': pnr.multiCity,
      travelers: pnr.travelers,
      market: body.market,
    };

    const params = new HttpParams({ fromObject: p });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http
      .post<any>(
        `${this.urlIropsPu}/exchange/pnr/purchase?`,
        IropsMapper.mapperResponsePurchase(body, pnr),
        { params }
      )
      .pipe(
        map((response) => {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          return response;
        }),
        catchError((error) => this.handlerError(error))
      );
  }

  set pnrResponse(data: any) {
    this._pnrResponse = data;
  }
  get pnrResponse(): any {
    return this._pnrResponse;
  }

  handlerError(error: HttpErrorResponse, loading: TypeLoading = TypeLoading.FOOTER_LOADING) {
    this._loadingService.hideLoading(loading);
    return throwError(error);
  }

  getFlightStatus(data: any): any {
    const params = new HttpParams({ fromObject: data as any });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);

    return this.http.get(`${this.urlMicro}`, { params }).pipe(
      map((response) => {
        this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        return IropsMapper.mapRespIropsMicro(response);
      }),
      catchError((error) => this.handlerError(error))
    );
  }

  makeRequestIropsMicro(arrayReq: Observable<any>[]) {
    let arrayApis = [];

    for (let req of arrayReq) {
      arrayApis.push(this.getFlightStatus(req));
    }

    return forkJoin(...arrayApis).toPromise();
  }
}
